import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private _storage = localStorage;

  storage(val: string = 'local') {
    if (val === 'session') {
      this._storage = sessionStorage;
    } else {
      this._storage = localStorage;
    }
    return val;
  }

  get(key: string) {
    return JSON.parse(this._storage.getItem(key) || '{}') || {};
  }

  set(key: string, value: any): boolean {
    this._storage.setItem(key, JSON.stringify(value));
    return true;
  }

  remove(key: string) {
    this._storage.removeItem(key);
  }

  clear() {
    this._storage.clear();
  }
}
